import { useState, useEffect } from 'react';
import {
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    Row,
    Col,
    Container,
} from 'reactstrap';
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";
import classnames from 'classnames';
import "react-datepicker/dist/react-datepicker.css";
import CardSecondary from '../../components/card/card-secondary';
import Main from '../../layout/main'
import ProjectsLoader from "../../components/projects/projectsSkeleton"
import API from '../../API';
import axios from 'axios';
const Myprojects = (props) => {
    const [allData, setallData] = useState([])
    const [hiredData, sethiredData] = useState([])
    const [completedData, setcompletedData] = useState([])
    const [bookmarksData, setbookmarksData] = useState([])
    const [allDataLoading, setAllDataLoading] = useState(true)
    const [hiredDataLoading, setHiredDataLoading] = useState(true)
    const [completedDataLoading, setCompletedDataLoading] = useState(true)
    const [bookmarksDataLoading, setBookmarksDataLoading] = useState(true)
    const [activeTab, setActiveTab] = useState('1');

    // Separate pagination states for each tab
    const [allCurrentPage, setAllCurrentPage] = useState(1)
    const [ongoingCurrentPage, setOngoingCurrentPage] = useState(1)
    const [draftCurrentPage, setDraftCurrentPage] = useState(1)
    const [historyCurrentPage, setHistoryCurrentPage] = useState(1)

    const [allTotalPages, setAllTotalPages] = useState(1)
    const [ongoingTotalPages, setOngoingTotalPages] = useState(1)
    const [draftTotalPages, setDraftTotalPages] = useState(1)
    const [historyTotalPages, setHistoryTotalPages] = useState(1)

    const [perPage] = useState(20)

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const fetchProjects = (endpoint, setData, setLoading, setTotalPages, page = 1) => {
        axios.get(`${API.baseURL}/v2/customers/my_projects/${endpoint}?page=${page}&per_page=${perPage}`, API.options)
            .then(response => {
                setData(response?.data?.data?.projects)
                const totalEntries = response?.data?.data?.pagination?.total_entries || 0
                setTotalPages(Math.ceil(totalEntries / perPage))
                setLoading(false)
            })
            .catch(() => setLoading(false))
    }

    const handlePageChange = (page, currentTab) => {
        switch(currentTab) {
            case '1':
                setAllCurrentPage(page);
                fetchProjects('all', setallData, setAllDataLoading, setAllTotalPages, page);
                break;
            case '2':
                setOngoingCurrentPage(page);
                fetchProjects('ongoing', sethiredData, setHiredDataLoading, setOngoingTotalPages, page);
                break;
            case '3':
                setDraftCurrentPage(page);
                fetchProjects('draft', setcompletedData, setCompletedDataLoading, setDraftTotalPages, page);
                break;
            case '4':
                setHistoryCurrentPage(page);
                fetchProjects('history', setbookmarksData, setBookmarksDataLoading, setHistoryTotalPages, page);
                break;
            default:
                break;
        }
    }

    const renderPagination = (currentPage, totalPages, tabId) => {
        if (totalPages <= 1) return null;

        return (
            <div className="d-flex justify-content-center mt-4">
                <button
                    className="btn mx-1 btn-outline-primary"
                    onClick={() => handlePageChange(currentPage - 1, tabId)}
                    disabled={currentPage === 1}
                >
                    &laquo;
                </button>

                {[...Array(totalPages)].map((_, index) => {
                    const pageNumber = index + 1;
                    
                    if (
                        pageNumber === 1 ||
                        pageNumber === totalPages ||
                        (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)
                    ) {
                        return (
                            <button
                                key={pageNumber}
                                className={`btn mx-1 ${currentPage === pageNumber ? 'btn-primary' : 'btn-outline-primary'}`}
                                onClick={() => handlePageChange(pageNumber, tabId)}
                            >
                                {pageNumber}
                            </button>
                        );
                    } else if (
                        pageNumber === currentPage - 2 ||
                        pageNumber === currentPage + 2
                    ) {
                        return <span key={pageNumber} className="mx-2">...</span>;
                    }
                    return null;
                })}

                <button
                    className="btn mx-1 btn-outline-primary"
                    onClick={() => handlePageChange(currentPage + 1, tabId)}
                    disabled={currentPage === totalPages}
                >
                    &raquo;
                </button>
            </div>
        );
    };

    useEffect(() => {
        // Initial data fetch for all tabs
        fetchProjects('all', setallData, setAllDataLoading, setAllTotalPages, allCurrentPage);
        fetchProjects('ongoing', sethiredData, setHiredDataLoading, setOngoingTotalPages, ongoingCurrentPage);
        fetchProjects('draft', setcompletedData, setCompletedDataLoading, setDraftTotalPages, draftCurrentPage);
        fetchProjects('history', setbookmarksData, setBookmarksDataLoading, setHistoryTotalPages, historyCurrentPage);
    }, []);
    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name="description" content="Check out all your projects at a single place.The projects you bidded,You bought and the bids approved.Check everything at a single place" />
                <title>EasyBids - Home Improvements :: My Projects</title>
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></link>
            </Helmet>
            <Main additionalClass_main="myprojects">
                <Nav tabs className="ebw-projects__navtab">
                    <Container>
                        <Row>
                            <NavItem className="ebw-tab__item">
                                <NavLink
                                    className={classnames({ active: activeTab === '1' })}
                                    onClick={() => { toggle('1'); }}
                                >
                                    All
                                </NavLink>
                            </NavItem>
                            <NavItem className="ebw-tab__item">
                                <NavLink
                                    className={classnames({ active: activeTab === '2' })}
                                    onClick={() => { toggle('2'); }}
                                >
                                    On Going
                                </NavLink>
                            </NavItem>

                            <NavItem className="ebw-tab__item">
                                <NavLink
                                    className={classnames({ active: activeTab === '3' })}
                                    onClick={() => { toggle('3'); }}
                                >
                                    Draft
                                </NavLink>
                            </NavItem>

                            <NavItem className="ebw-tab__item">
                                <NavLink
                                    className={classnames({ active: activeTab === '4' })}
                                    onClick={() => { toggle('4'); }}
                                >
                                    History
                                </NavLink>
                            </NavItem>
                        </Row>
                    </Container>
                </Nav>
                <section className="ebw-section ebw-section__pages">
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                            <Container>
                                <>
                                    <div className="d-md-flex justify-content-between">
                                        <div className="ebw-title__primary">All</div>
                                    </div>
                                    {allDataLoading ?
                                        <div className="mt-3">
                                            <ProjectsLoader />
                                        </div> :
                                        <>
                                            {allData?.length == 0 &&
                                                <Row>
                                                    <Col sm="12 mt-5 mt-md-8" >
                                                        <div className="ebw-section__empty position-relative">
                                                            <div className="ebw-section__empty-imgs w-100">
                                                                <img className="w-100 ebw-section__empty-background" src="/images/projects/project-empty-background.svg" alt="" />
                                                            </div>
                                                            <div className="ebw-section__empty-content d-flex align-items-end position-absolute">
                                                                <div className="ebw-section__empty-title h-100 d-flex align-items-center ebw-title__primary--white ">You currently have no projects. Browse available projects to get started.</div>
                                                                <div className="ebw-section__empty-img"><img className="w-100" src="/images/projects/project-empty-img.png" alt="" /></div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            }
                                            <Row>
                                                {allData?.length !== 0 && allData?.map((projectInBidding, index) => {
                                                        return (
                                                            <Col sm="6" lg="4" className="mt-5" key={projectInBidding.id}>
                                                                <CardSecondary
                                                                    projectName={projectInBidding.name}
                                                                    projectImage={projectInBidding.project_image_url}
                                                                    projectDate={projectInBidding.created_at}
                                                                    projectCategory={projectInBidding.project_type}
                                                                    projectSubCategory={projectInBidding.project_sub_type}
                                                                    projectLinks={`/project-detail/${projectInBidding.id}/my_projects`}
                                                                    status={projectInBidding.status}
                                                                    no_of_bids={projectInBidding.no_of_bids}
                                                                    project_id={projectInBidding.id}
                                                                />
                                                            </Col>
                                                        )
                                                    }
                                                )}
                                            </Row>
                                        </>
                                    }
                                </>
                                {!allDataLoading && allData?.length > 0 && renderPagination(allCurrentPage, allTotalPages, '1')}
                            </Container>
                        </TabPane>

                        <TabPane tabId="2">
                            <Container>
                                <>
                                    <div className="d-md-flex justify-content-between">
                                        <div className="ebw-title__primary">On Going</div>
                                    </div>
                                    {hiredDataLoading ?
                                        <div className="ebw-data__loader">
                                            <ProjectsLoader />
                                        </div> :
                                        <>
                                            {hiredData && hiredData.length == 0 &&
                                                <Row>
                                                    <Col sm="12 mt-5 mt-md-8" >
                                                        <div className="ebw-section__empty position-relative">
                                                            <div className="ebw-section__empty-imgs w-100">
                                                                <img className="w-100 ebw-section__empty-background" src="/images/projects/project-empty-background.svg" alt="" />
                                                            </div>
                                                            <div className="ebw-section__empty-content d-flex align-items-end position-absolute">
                                                                <div className="ebw-section__empty-title h-100 d-flex align-items-center ebw-title__primary--white ">You currently have no ongoing projects.</div>
                                                                <div className="ebw-section__empty-img"><img className="w-100" src="/images/projects/project-empty-img.png" alt="" /></div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            }
                                            <Row>
                                                {hiredData.length != 0 && hiredData.map((projectHired, index) => {
                                                    return (
                                                            <Col key={index} sm="6" lg="4" className="mt-5">
                                                                <CardSecondary
                                                                    projectName={projectHired.name}
                                                                    bidAmount={projectHired.bid_amount}
                                                                    bidtype={projectHired.bid_type}
                                                                    projectEstimationHour={projectHired.hours}
                                                                    projectImage={projectHired.project_image_url}
                                                                    projectDate={projectHired.created_at}
                                                                    projectCategory={projectHired.project_type}
                                                                    projectSubCategory={projectHired.project_sub_type}
                                                                    projectLocation={projectHired.city}
                                                                    projectLinks={`/project-detail/${projectHired.id}/my_projects`}
                                                                    Estimate
                                                                    project_post_type={projectHired.project_post_type}
                                                                    status={projectHired.status}
                                                                    project_status={projectHired.status}
                                                                    lead_purchased={projectHired.lead_purchased}
                                                                    no_of_bids={projectHired.no_of_bids}
                                                                    project_id={projectHired.id}
                                                                />
                                                            </Col>
                                                        )
                                                }
                                                )}
                                            </Row></>}
                                </>
                                {!hiredDataLoading && hiredData?.length > 0 && renderPagination(ongoingCurrentPage, ongoingTotalPages, '2')}
                            </Container>
                        </TabPane>

                        <TabPane tabId="3">
                            <Container>
                                <>
                                    <div className="d-md-flex justify-content-between">
                                        <div className="ebw-title__primary">Draft</div>
                                    </div>
                                    {completedDataLoading ?
                                        <div className="ebw-data__loader">
                                            <ProjectsLoader />
                                        </div> :
                                        <>
                                            {!completedData &&
                                                <Row>
                                                    <Col sm="12 mt-5 mt-md-8" >
                                                        <div className="ebw-section__empty position-relative">
                                                            <div className="ebw-section__empty-imgs w-100">
                                                                <img className="w-100 ebw-section__empty-background" src="/images/projects/project-empty-background.svg" alt="" />
                                                            </div>
                                                            <div className="ebw-section__empty-content d-flex align-items-end position-absolute">
                                                                <div className="ebw-section__empty-title h-100 d-flex align-items-center ebw-title__primary--white ">You currently have no draft projects.</div>
                                                                <div className="ebw-section__empty-img"><img className="w-100" src="/images/projects/project-empty-img.png" alt="" /></div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            }
                                            {completedData && completedData.length == 0 &&
                                                <Row>
                                                    <Col sm="12 mt-5 mt-md-8" >
                                                        <div className="ebw-section__empty position-relative">
                                                            <div className="ebw-section__empty-imgs w-100">
                                                                <img className="w-100 ebw-section__empty-background" src="/images/projects/project-empty-background.svg" alt="" />
                                                            </div>
                                                            <div className="ebw-section__empty-content d-flex align-items-end position-absolute">
                                                                <div className="ebw-section__empty-title h-100 d-flex align-items-center ebw-title__primary--white ">You have no draft projects yet. Create a new project to get started!</div>
                                                                <div className="ebw-section__empty-img"><img className="w-100" src="/images/projects/project-empty-img.png" alt="" /></div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            }
                                            <Row>
                                                {completedData.length != 0 && completedData.map((projectCompleted, index) => {
                                                        return (
                                                                <Col key={index} sm="6" lg="4" className="mt-5">
                                                                    <CardSecondary
                                                                        projectName={projectCompleted.name}
                                                                        bidAmount={projectCompleted.bid_amount}
                                                                        bidtype={projectCompleted.bid_type}
                                                                        projectEstimationHour={projectCompleted.hours}
                                                                        projectImage={projectCompleted.project_image_url}
                                                                        projectDate={projectCompleted.created_at}
                                                                        projectCategory={projectCompleted.project_type}
                                                                        projectSubCategory={projectCompleted.project_sub_type}
                                                                        projectLocation={projectCompleted.city}
                                                                        projectLinks={`/project-detail/${projectCompleted.id}/my_projects`}
                                                                        Estimate
                                                                        project_post_type={projectCompleted.project_post_type}
                                                                        status={projectCompleted.status}
                                                                        project_status={projectCompleted.status}
                                                                        lead_purchased={projectCompleted.lead_purchased}
                                                                        no_of_bids={projectCompleted.no_of_bids}
                                                                        project_id={projectCompleted.id}
                                                                    />
                                                                </Col>
                                                            )
                                                    }
                                                    )}
                                            </Row></>}
                                </>
                                {!completedDataLoading && completedData?.length > 0 && renderPagination(draftCurrentPage, draftTotalPages, '3')}
                            </Container>
                        </TabPane>

                        <TabPane tabId="4">
                            <Container>
                                <>
                                    <div className="d-md-flex justify-content-between">
                                        <div className="ebw-title__primary">History</div>
                                    </div>
                                    {bookmarksDataLoading ?
                                        <div className="ebw-data__loader">
                                            <ProjectsLoader />
                                        </div> :
                                        <>
                                            {!bookmarksData &&
                                                <Row>
                                                    <Col sm="12 mt-5 mt-md-8" >
                                                        <div className="ebw-section__empty position-relative">
                                                            <div className="ebw-section__empty-imgs w-100">
                                                                <img className="w-100 ebw-section__empty-background" src="/images/projects/project-empty-background.svg" alt="" />
                                                            </div>
                                                            <div className="ebw-section__empty-content d-flex align-items-end position-absolute">
                                                                <div className="ebw-section__empty-title h-100 d-flex align-items-center ebw-title__primary--white ">You currently have no projects. Browse available projects to get started.</div>
                                                                <div className="ebw-section__empty-img"><img className="w-100" src="/images/projects/project-empty-img.png" alt="" /></div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            }
                                            {bookmarksData && bookmarksData?.length == 0 &&
                                                <Row>
                                                    <Col sm="12 mt-5 mt-md-8" >
                                                        <div className="ebw-section__empty position-relative">
                                                            <div className="ebw-section__empty-imgs w-100">
                                                                <img className="w-100 ebw-section__empty-background" src="/images/projects/project-empty-background.svg" alt="" />
                                                            </div>
                                                            <div className="ebw-section__empty-content d-flex align-items-end position-absolute">
                                                                <div className="ebw-section__empty-title h-100 d-flex align-items-center ebw-title__primary--white ">You currently have no projects.</div>
                                                                <div className="ebw-section__empty-img"><img className="w-100" src="/images/projects/project-empty-img.png" alt="" /></div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            }
                                            <Row>
                                                {bookmarksData?.length != 0 && bookmarksData?.map((projectbookmarks, index) => {
                                                        return (
                                                                <Col key={index} sm="6" lg="4" className="mt-5">
                                                                    <CardSecondary
                                                                        projectName={projectbookmarks.name}
                                                                        bidAmount={projectbookmarks.bid_amount}
                                                                        bidtype={projectbookmarks.bid_type}
                                                                        projectEstimationHour={projectbookmarks.hours}
                                                                        projectImage={projectbookmarks.project_image_url}
                                                                        projectDate={projectbookmarks.created_at}
                                                                        projectCategory={projectbookmarks.project_type}
                                                                        projectSubCategory={projectbookmarks.project_sub_type}
                                                                        projectLocation={projectbookmarks.city}
                                                                        projectLinks={`/project-detail/${projectbookmarks.id}/my_projects`}
                                                                        Estimate
                                                                        project_post_type={projectbookmarks.project_post_type}
                                                                        status={projectbookmarks.status}
                                                                        project_status={projectbookmarks.status}
                                                                        lead_purchased={projectbookmarks.lead_purchased}
                                                                        no_of_bids={projectbookmarks.no_of_bids}
                                                                        project_id={projectbookmarks.id}
                                                                    />
                                                                </Col>
                                                            )
                                                    }
                                                    )}
                                            </Row></>}
                                    {!bookmarksDataLoading && bookmarksData?.length > 0 && renderPagination(historyCurrentPage, historyTotalPages, '4')}
                                </>
                            </Container>
                        </TabPane>
                    </TabContent>
                </section>
            </Main>
        </div>
    );
}

const mapStateToProps = state => ({
    projectsData: state.allProjectsData
});
export default connect(mapStateToProps, {})(Myprojects);